import { NumberInput, coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'loader',
    templateUrl: './loader.html',
    styleUrls: ['./loader.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'loader'
    }
})

export class Loader {
    @Input() public active: boolean = false;
    @Input() public label: string = "";
    @Input() public login: boolean = false;
    @Input() public productLabel: string = "";

    private _strokeWidth: number = 0;
    private _diameter: number = 0;
    private timeout;


    @Input()
    get strokeWidth(): number {
        return this._strokeWidth;
    }
    set strokeWidth(value: NumberInput) {
        this._strokeWidth = coerceNumberProperty(value);
    }

    @Input()
    get diameter(): number {
        return this._diameter;
    }
    set diameter(size: NumberInput) {
        this._diameter = coerceNumberProperty(size);
    }

    public show() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            this.active = true;
            this.timeout = null;
        }, 100);
    }

    public hide() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.active = false;
    }

    public showDirectly() {
        this.active = true;
    }


    public hideDirectly() {
        this.active = false;
    }
}
